<div mat-dialog-content>ההזמנה עודכנה בהצלחה , תודה</div>
<div class="text-center p-2" mat-dialog-actions>
</div>